/** [no description; please add] */
function initializeCountdowns() {

    /**
     * @param {HTMLElement} countdown
     */
    function initializeCountdown(/** @type {HTMLTimeElement} */ countdown) {
        const targetTime = new Date(countdown.getAttribute('datetime'));
        const shouldPadWithZeroes = countdown.dataset.padZeroes !== 'false';

        /**
         * Updates the countdown display by modifying individual elements
         */
        function updateTime() {
            const diffInSeconds = Math.floor(Math.max(targetTime.getTime() - Date.now(), 0) / 1000);

            const days = Math.floor(diffInSeconds / (24 * 60 * 60));
            const hours = Math.floor((diffInSeconds % (24 * 60 * 60)) / (60 * 60));
            const minutes = Math.floor((diffInSeconds % (60 * 60)) / 60);
            const seconds = Math.floor(diffInSeconds % 60);

            const formatValue = (value) => shouldPadWithZeroes ? String(value).padStart(2, '0') : String(value);

            // Format numbers according to component configuration
            const daysString = formatValue(days);
            const hoursString = formatValue(hours);
            const minutesString = formatValue(minutes);
            const secondsString = formatValue(seconds);

            // Update the number values
            const daysElement = countdown.querySelector('.js-countdown-days');
            const hoursElement = countdown.querySelector('.js-countdown-hours');
            const minutesElement = countdown.querySelector('.js-countdown-minutes');
            const secondsElement = countdown.querySelector('.js-countdown-seconds');

            if (daysElement) daysElement.textContent = daysString;
            if (hoursElement) hoursElement.textContent = hoursString;
            if (minutesElement) minutesElement.textContent = minutesString;
            if (secondsElement) secondsElement.textContent = secondsString;

            // Update the labels for proper pluralization
            const daysLabelElement = countdown.querySelector('.js-countdown-days-label');
            if (daysLabelElement) {
                daysLabelElement.textContent = days !== 1 ? daysLabelElement.dataset.labelPlural : daysLabelElement.dataset.labelSingular;
            }

            if (diffInSeconds > 0) {
                setTimeout(updateTime, 1000);
            }
        }

        updateTime();
    }

    const timeElements = document.querySelectorAll('.js-newsletterCountdown');

    timeElements.forEach(initializeCountdown);
}

// Initialize on page load
document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initializeCountdowns)
    : initializeCountdowns();

// Re-initialize countdowns when content is dynamically loaded
document.addEventListener('htmx:afterSwap', initializeCountdowns);
document.addEventListener('lazy:initContent', initializeCountdowns);
